module.exports = __webpack_public_path__ + "static/media/ipad-pro-set-genie-app-store-reduced.4cb2abfd.jp2";